import { useState } from 'react';

import Tab from '~/common/components/Tab/Tab';
import TabPanel from '~/common/components/Tab/TabPanel';
import Tabs from '~/common/components/Tab/Tabs';
import ScrollIntoViewContainer from '~/pages/Loan1003DataGrids/common/components/ScrollIntoViewContainer';

import { AddressInfoForm } from './addressInfo/AddressInfoForm';
import { BorrowerDataForm } from './borrowerData/BorrowerDataForm';
import { DeclarationsForm } from './borrowerDeclarations/DeclarationsForm';

function a11yTabProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
    index,
  };
}

type BorrowerFormProps = {
  borrowerId: number;
};

export function BorrowerForm(props: Readonly<BorrowerFormProps>) {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <ScrollIntoViewContainer valueToWatch>
      <Tabs
        value={activeTab}
        onChange={(_, value) => setActiveTab(value)}
        centered
        aria-label="Borrower Tabs"
      >
        <Tab label="Borrower Data" {...a11yTabProps(0)} />
        <Tab label="Address Info" {...a11yTabProps(1)} />
        <Tab label="Declarations" {...a11yTabProps(2)} />
      </Tabs>
      <TabPanel value={activeTab} index={0}>
        <BorrowerDataForm borrowerId={props.borrowerId} />
      </TabPanel>
      <TabPanel value={activeTab} index={1}>
        <AddressInfoForm borrowerId={props.borrowerId} />
      </TabPanel>
      <TabPanel value={activeTab} index={2}>
        <DeclarationsForm borrowerId={props.borrowerId} />
      </TabPanel>
    </ScrollIntoViewContainer>
  );
}
